module.exports = __webpack_public_path__ + "static/media/logo.e672d56d.svg";